import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';

const Layout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const openAnalyticsPreferences = () => {
    window.dispatchEvent(new CustomEvent('analytics-preferences:open'));
  };

  return (
    <div className="layout">
      <header className="header">
        <div className="logo">
          <img src="/app_icon.png" alt="Tonometer Scan" className="logo-icon" />
          <span className="logo-text">Tonometer Scan</span>
        </div>
        <button 
          className="mobile-menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
          <Link to="/features" onClick={() => setIsMobileMenuOpen(false)}>Features</Link>
          <Link to="/how-it-works" onClick={() => setIsMobileMenuOpen(false)}>How It Works</Link>
          <Link to="/pricing" onClick={() => setIsMobileMenuOpen(false)}>Pricing</Link>
          <Link to="/screenshots" onClick={() => setIsMobileMenuOpen(false)}>Screenshots</Link>
          <Link to="/download" onClick={() => setIsMobileMenuOpen(false)}>Download</Link>
        </nav>
      </header>
      
      <main className="main-content">
        {children}
      </main>
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Product</h4>
            <ul>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/pricing">Pricing</Link></li>
              <li><Link to="/screenshots">Screenshots</Link></li>
              <li><Link to="/download">Download</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li>
                <button type="button" className="analytics-preferences-button" onClick={openAnalyticsPreferences}>
                  Analytics preferences
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 Tonometer Scan. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
